<template>
  <div class="d-flex flex-column align-center mb-4">
    <span class="primary--text font-weight-bold text-h6 mb-2">
      {{ this.area.name }}
    </span>

    <div class="image" @click="viewArea">
      <v-img class="map-marker-icon" src="@/assets/icons/location.svg"> </v-img>

      <v-img
        :aspect-ratio="16 / 9"
        width="85vw"
        :src="image"
        @error="onImageError"
        style="border-radius: 15px"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  props: {
    area: Object,
  },

  data() {
    return {
      failed_image: false,
    };
  },

  computed: {
    image() {
      return this.failed_image
        ? "https://iguide.mobics.gr/images//ilioupoli_opt_.jpg"
        : `https://api.e-naxios.com/images/${this.area.image.file_name}`;
    },
  },

  methods: {
    ...mapMutations(["setCurrentArea"]),

    onImageError() {
      console.log("?");
      this.failed_image = true;
    },

    viewArea() {
      this.setCurrentArea(this.area);
      this.$router.push(`/islands/area/${this.area.id}`);
    },
  },
};
</script>

<style scoped lang="scss">
.image {
  position: relative;
  cursor: pointer;
}

.image:after {
  content: "";
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-right: 20px solid white;
  border-top: 20px solid white;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;

  position: absolute;
  left: 50%;
  top: 0;
  margin-left: -20px;
}

.map-marker-icon {
  position: absolute;
  left: 50%;
  top: -5px;
  margin-left: -8px;
  z-index: 1;
}
</style>
